import React from "react";
import { motion } from "framer-motion";
import { fadeIn } from "./motionUtils";
import { resume } from "../data/resume";

export const Experience = () => {
  return (
    <>
      {resume.experiences.map((experience, index) => {
        return (
          <div
            key={index}
            className="w-full flex flex-col space-y-1 font-poppins font-thin text-sm sm:text-base"
          >
            <motion.div
              variants={fadeIn("up", "tween", 0, 1.5)}
              whileInView="show"
              initial="hidden"
              viewport={{ once: false, amount: 0.05 }}
              className="w-full"
            >
              <div className="flex flex-col md:flex-col lg:flex-row font-lora font-bold">
                <h1 className="text-sm md:text-lg lg:text-base">
                  <span className="font-bold">{experience.company_name}</span> -{" "}
                  <span>{experience.company_location}</span>
                </h1>
                <h1 className="text-sm md:text-lg lg:text-base">
                  <i>{`—${experience.position}`}</i>
                </h1>
              </div>
              <p className="uppercase text-xs sm:text-[0.75rem] font-semibold">
                {`${experience.start_date} - ${experience.end_date}`}
              </p>
              <p className="text-sm">{experience.company_description}</p>
              {experience.responsibilities.length >= 1 ? (
                <p className="text-sm">
                  {`My key
              ${
                experience.end_date === "PRESENT"
                  ? "responsibilities"
                  : "accomplishments"
              }
              are as follows:`}
                </p>
              ) : (
                ""
              )}
              <div className="w-[95%] flex flex-col items-start justify-start pl-3 sm:pl-6 text-sm">
                {experience.responsibilities.map((responsibility, index) => {
                  return <li key={index}>{responsibility}</li>;
                })}
              </div>
              {experience.app_url.length > 2 ? (
                <a
                  href={experience.app_url}
                  target={"_blank"}
                  rel="noreferrer"
                  className="text-sm"
                >
                  App Url:{" "}
                  <span className="text-[#ffa500]">
                    <b>{experience.app_url}</b>
                  </span>
                </a>
              ) : (
                ""
              )}
              <br />
              <br />
            </motion.div>
          </div>
        );
      })}
    </>
  );
};
